module.exports = __webpack_public_path__ + "static/design-24b80af429de299d296d0ca04544f7df.svg";